// Split Product title at #
document.addEventListener('DOMContentLoaded', function () {
  const productTitle = document.querySelector('.product-title');
  console.log('Product title element:', productTitle);

  if (productTitle) {
    console.log('Current innerHTML:', productTitle.innerHTML);

    if (productTitle.innerHTML.includes('#')) {
      let text = productTitle.innerHTML;
      let parts = text.split('#');
      productTitle.innerHTML = parts[0] + '<span class="ts-title-product-code">#' + parts[1] + '</span>';
    }
  }
});

function toggleVendorEnquiry(event) {
  event.preventDefault();

  // Set product title in form
  const productTitle = document.querySelector('.product-title');
  if (productTitle) {
    const titleInput = document.getElementById('product-title');
    if (titleInput) {
      titleInput.value = productTitle.textContent.trim();
    }
  }

  // Toggle Form Visibility
  const form = document.getElementById('vendor-enquiry-form');
  const arrow = event.currentTarget.querySelector('.arrow');

  if (form.style.display === 'none' || form.style.display === '') {
    form.style.display = 'block';
    arrow.textContent = '▼';
  } else {
    form.style.display = 'none';
    arrow.textContent = '►';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // Auto-open panel if form was submitted successfully
  const successMsg = document.getElementById('success-msg');
  if (successMsg) {
    const form = document.getElementById('vendor-enquiry-form');
    form.parentNode.insertBefore(successMsg, form);

    setTimeout(function () {
      successMsg.style.display = 'none';
    }, 7000);
  }
});
